import React, { useContext, useMemo } from 'react';
import { useLabels, useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { FiltersContext, IncentivesContext, UIContext } from '../contexts';
import { buildSlugMap, FACET_KEYS } from '../hooks/useDeepLinking';
import { FACET_HEADINGS } from './FacetGroup';
import { facetChipRemoveEvent } from '../utils/wueTracking';
import OFFER_TYPE_LABEL_KEYS from '../utils/incentiveTypeMap';

const ActiveFilterChips = () => {
	const { activeFilters, deselectFacet } = useContext(FiltersContext);
	const { incentives } = useContext(IncentivesContext);
	const { isMobile } = useContext(UIContext);
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();

	const byVehicle = incentives?.byVehicle;
	const facetLabelMap = useMemo(() => buildSlugMap(byVehicle), [byVehicle]);

	const chips = useMemo(() => {
		const result = [];
		FACET_KEYS.forEach((key) => {
			(activeFilters[key] || []).forEach((value) => {
				let chipLabel = facetLabelMap[key]?.[value] || value;
				if (key === 'offerTypes') {
					const labelKey = OFFER_TYPE_LABEL_KEYS[value];
					if (labelKey) {
						const resolved = labels.get(labelKey);
						if (resolved !== labelKey) {
							chipLabel = resolved;
						}
					}
				}
				result.push({
					facetKey: key,
					value,
					label: chipLabel
				});
			});
		});
		return result;
	}, [activeFilters, facetLabelMap, labels]);

	if (chips.length === 0) return null;

	return (
		<div aria-live="polite">
			<div
				className={`active-filter-chips d-flex flex-wrap${
					isMobile ? ' py-3' : ' my-4'
				}`}
				role="list"
				aria-label={labels.get('INCENTIVES_ACTIVE_FILTERS')}
			>
				{chips.map((chip) => (
					<button
						key={`${chip.facetKey}-${chip.value}`}
						type="button"
						className="pill chip chip-default chip-condensed d-inline-flex align-items-center mr-3 mb-3"
						aria-label={`Remove ${chip.label} filter`}
						onClick={() => {
							trackEvent(
								widgetName,
								windowId,
								facetChipRemoveEvent({
									heading: FACET_HEADINGS[chip.facetKey],
									value: chip.value
								})
							);
							deselectFacet(chip.facetKey, chip.value);
						}}
					>
						{chip.label}
						<i
							className="ddc-icon ddc-icon-remove2 pl-3"
							aria-hidden="true"
						/>
					</button>
				))}
			</div>
		</div>
	);
};

export default ActiveFilterChips;
